import React from 'react';
import { AccordionBodyItem } from 'component/Accordion';

export const SocialServices = (props) => {
  const handleBeneficiaries = (value) => {
    props.setFormData((prevFormData) => ({
      ...prevFormData,
      info: {
        ...prevFormData.info,
        landuse_and_beneficiaries: {
          ...prevFormData.info.landuse_and_beneficiaries,
          social_services: Number(value),
        },
      },
    }));
  };

  return (
    <AccordionBodyItem
      accordionSubId={(
        <div>
          <span>8.2</span>
          <span className="star">*</span>
        </div>
      )}
      titleUA="Громадські/державні служби"
      titleEN="Social services"
      children={(
        <div className="flex-group">
          <input
            placeholder="0"
            id="social_services"
            name="social_services"
            className="number"
            value={props.formData.info.landuse_and_beneficiaries.social_services}
            autoComplete="off"
            disabled={props.disabled}
            options={{
              numericOnly: true,
              stripLeadingZeroes: true,
            }}
            onChange={(e) => {
              const newValue = Number(e.target.value);
              const total = props.checkPercent('social_services') + newValue;
              if (total <= 100) {
                handleBeneficiaries(newValue);
              } else {
                e.preventDefault();
              }
            }}
          />
          <span>%</span>
        </div>
      )}
    />
  );
};
